import { t } from '@lingui/macro';

import { SERVICE_TYPE_CHOICES } from '@rover/constants/src/translations/service.constants';
import Boarding from '@rover/icons/svg/boarding.svg';
import Daycare from '@rover/icons/svg/daycare.svg';
import DogTraining from '@rover/icons/svg/dog-training.svg';
import DropIn from '@rover/icons/svg/drop-in.svg';
import Grooming from '@rover/icons/svg/grooming.svg';
import Sitting from '@rover/icons/svg/sitting.svg';
import Walking from '@rover/icons/svg/walking.svg';
import type { ServiceTypeOption } from '@rover/types/src/ServiceType';

export const SERVICE_SELECTION_OPTIONS = (): ServiceTypeOption[] => [
  {
    title: t`Boarding`,
    subtitle: t`in the sitter's home`,
    icon: Boarding,
    value: SERVICE_TYPE_CHOICES.boarding,
  },
  {
    title: t`House Sitting`,
    subtitle: t`in your home`,
    icon: Sitting,
    value: SERVICE_TYPE_CHOICES.traveling,
  },
  {
    title: t`Drop-In Visits`,
    subtitle: t`visits in your home`,
    icon: DropIn,
    value: SERVICE_TYPE_CHOICES.dropIn,
  },
  {
    title: t`Doggy Day Care`,
    subtitle: t`in the sitter's home`,
    icon: Daycare,
    value: SERVICE_TYPE_CHOICES.dayCare,
  },
  {
    title: t`Dog Walking`,
    subtitle: t`in your neighborhood`,
    icon: Walking,
    value: SERVICE_TYPE_CHOICES.walking,
  },
  {
    title: t`Dog Training`,
    // DEV-104195 TODO: translate
    subtitle: 'with a private trainer',
    value: SERVICE_TYPE_CHOICES.training,
    icon: DogTraining,
  },
  {
    title: t`Grooming`,
    subtitle: 'at your home or a groomer’s home',
    value: SERVICE_TYPE_CHOICES.grooming,
    icon: Grooming,
  },
];
